export const RoadmapData = [
  {
    id: 1,
    title: "Q2 2022",
    description:
      "Call for entries for the Haydenfilms 5.0 Online Film Festival announcement",
  },
  {
    id: 2,
    title: "Q3 2022",
    description: "Cemboo Beta launches",
  },
  {
    id: 3,
    title: "Q4 2022",
    description:
      "Official Submission Deadline for the Haydenfilms 5.0 Online Film Festival",
  },
  {
    id: 4,
    title: "Q4 2022",
    description: "Cemboo Use Case(s) deploys",
  },
  {
    id: 5,
    title: "Q1 2023",
    description:
      "Haydenfilms 5.0 Online Film Festival, presented by Cemboo, goes live",
  },

  {
    id: 6,
    title: "Q1 2023",
    description: "Seed funding announcement",
  },
  {
    id: 7,
    title: "Q3 2023",
    description: "Haydenfilms 5.0 Film Festival Awards, presented by Cemboo",
  },
];
